export enum FiatDepositStepNames {
	SelectDepositType = "select-deposit-type",
	SelectFiatWallet = "select-fiat-wallet",
	SelectCryptoWallet = "select-crypto-wallet",
	SelectNetwork = "deposit-select-network-modal",
	CryptoDepositWarning = "deposit-warning",
	CryptoDepositSummary = "crypto-deposit-summary",
	DepositCryptoWallet = "deposit-crypto-wallet",
	DepositNonDefaultAddress = "non-default-address",
	SelectPaymentOption = "select-payment-option",
	EnterAmount = "enter-amount",
	Summary = "summary",
	DepositVerifyPin = "deposit-verify-pin",
	DepositPending = "deposit-pending",
	ManualDepositReminder = "manual-deposit-reminder",
	ManualDepositInstructions = "manual-deposit-instructions",
	SelectBank = "select-bank",
	SelectBankChild = "select-bank-child",
	ConnectToBank = "connect-to-bank"
}
